module.exports = function() {
  return new Worker(__webpack_public_path__ + "2c3271ef14ad8adfeb9f.worker.js");
};